import { render } from "./IconQuote.vue?vue&type=template&id=b44cb662"
import script from "./IconQuote.vue?vue&type=script&lang=js"
export * from "./IconQuote.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__